import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import Srcset from "./Srcset";
import { bodyOverflow } from "@/helpers/userHelpers";
import { retainFocusInsideDrawer } from "@/helpers/adaHelper";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";

export default function PopUp(props) {
  const [show, setShow] = useState(false);
  const popupRef = useRef(null)
  const stateRef = useRef(show)

  const closeHandler = (e) => {
    setShow(false);
    props.onClose(false); 
  };
  const isDesktop= useMediaQuery("(min-width: 1025px)");

  useEffect(() => {
    setShow(props.show);
    stateRef.current = props.show
  }, [props.show]);

  useEffect(()=> {
    if(isDesktop){
      const node = popupRef.current;
      if (node) {
        // on focusout, add the focus back to the drawer if drawer is open
        node.addEventListener('focusout', (e) => retainFocusInsideDrawer(e, popupRef, stateRef.current));
      }

      return () => {
        if (node) {
          node.removeEventListener('focusout', (e) => retainFocusInsideDrawer(e, popupRef, stateRef.current));
        }
      };
    }
  },[isDesktop])

  var IconSrc = props.closeIcon ? "images/Icons/Chevron/large.svg" : "images/Icons/Cross/Large.svg";

  return (
    <>
      <div tabIndex={-1} ref={popupRef} className="custom-popup">
        <div
          style={{
            visibility: show ? "visible" : "hidden",
            opacity: show ? "1" : "0",
          }}
          className="overlay"
        >
          <div className="popup" style={{marginTop: props.addTopSpacing ? "4.5rem" :""}}>
            <span className="close" onClick={closeHandler}>
              <Srcset
                tabIndex={0}
                svgFile={true}
                src={IconSrc}
                requirePath={true}
                height="20"
                width="20"
                alt="cross"
              />
            </span>
            <div className="content">{props.children}</div>
          </div>
        </div>
      </div>
    </>
  );
}
PopUp.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
